export abstract class Anlage {
    name = ""
    beschreibung = ""
    _frontendId = -1

    abstract get notEmpty(): boolean
    abstract toJSON(): Record<string, unknown>
}
